import React from 'react';
import { Col, Form, Input, InputNumber, Row, Select } from 'antd';

const EquipmentDetailsFields = () => (
  <>
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item
          name="equipment_name"
          label="Equipment Name"
          rules={[{ required: true, whitespace: true, message: 'Please input the equipment name!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="equipment_brand"
          label="Brand"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="equipment_model"
          label="Model"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="equipment_serial_number"
          label="Serial Number"
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name="equipment_type_name"
          label="Type"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="equipment_status_name"
          label="Status"
        >
          <Select>
            <Select.Option value="In-Service">In-Service</Select.Option>
            <Select.Option value="Out-of-Service">Out-of-Service</Select.Option>
            <Select.Option value="Sold">Sold</Select.Option>
            <Select.Option value="Removed">Removed</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="equipment_group_name"
          label="Group"
        >
          <Input />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={16}>
      <Col span={12}>
        <Form.Item
          name="walks_coverage_rate"
          label="Walks Coverage Rate"
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          name="lots_coverage_rate"
          label="Lots Coverage Rate"
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          name="travel_km"
          label="Travel KM"
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name="flag_type"
          label="Flag Type"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="staff_limit"
          label="Staff Limit"
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          name="season"
          label="Season"
        >
          <Select allowClear placeholder="Select season">
            <Select.Option value="winter">Winter</Select.Option>
            <Select.Option value="summer">Summer</Select.Option>
            <Select.Option value="year_round">Year-round</Select.Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
  </>
);

export default EquipmentDetailsFields;
